// extracted by mini-css-extract-plugin
export default {"title-table":"style_title-table__AMWJG","container-body":"style_container-body__0W9-G"};